import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterLinkComponent } from '../components/shared/footer-link/footer-link.component';

@NgModule({
  declarations: [FooterLinkComponent],
  imports: [CommonModule, RouterModule],
  exports: [FooterLinkComponent, CommonModule, RouterModule],
})
export class SharedModule {}
